import { render, staticRenderFns } from "./ad-campaign-manager.vue?vue&type=template&id=16b5e501&scoped=true&"
import script from "./ad-campaign-manager.vue?vue&type=script&lang=js&"
export * from "./ad-campaign-manager.vue?vue&type=script&lang=js&"
import style0 from "./ad-campaign-manager.vue?vue&type=style&index=0&id=16b5e501&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b5e501",
  null
  
)

export default component.exports